import styled from 'styled-components';

const TH = styled.td`
  padding: 0.75rem;
  border: 1px solid #e9ecef;
  vertical-align: bottom;
  font-weight: bold;
  background-color:  ${(props) => (props.backgroundColor) ? props.backgroundColor : '#031c30'};
  color: ${(props) => (props.color) ? props.color : '#eff0f3'};
`;

export default TH;



// WEBPACK FOOTER //
// ./app/components/Table/TH.js